import {
  formatDate,
  formatDateTime,
  formatShortDateTimeWithWeekday,
  formatShortDateWithWeekday,
} from "@clipboard-health/date-time";
import { isSameYear } from "date-fns";

/**
 * Formats a date into a string in the format "Thu, Jan 15 4:20 PM" or "Jan 15, 2023 4:20 PM"
 * depending on whether the year is the same as the current year
 */
export function formatPaymentDetailsDateWithTime(date: Date): string {
  return isSameYear(date, new Date()) ? formatShortDateTimeWithWeekday(date) : formatDateTime(date);
}

/**
 * Formats a date into a string in the format "Thu, Jan 15" or "Jan 15, 2023"
 * depending on whether the year is the same as the current year
 */
export function formatPaymentDetailsDate(date: Date): string {
  return isSameYear(date, new Date()) ? formatShortDateWithWeekday(date) : formatDate(date);
}
